export default __webpack_public_path__ + "static/media/logo.47201d43.png";